exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App-header {\n  background-color: rgb(22,175,202);\n  height: 80px;\n  padding: 20px;\n  color: white;\n}\n\n.noscroll {\n  overflow: hidden;\n}\n\nbody {\n  background-color: rgb(234,234,234);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/App.css
// module id = k0UN
// module chunks = main